import React, {useState} from 'react';
import {Col, CustomInput, Popover, PopoverBody, Row} from 'reactstrap';
// import {Card, CardBody, CardFooter, CardHeader, CardImg, CardImgOverlay, Col, Container, Row,} from "reactstrap";
import moment from "moment";
import {getAgeGroupDiv, getTagsCommaSeparated} from "../../../../../util/utility";
import assets from '../../../../../util/assets';
import "./index.css";
import ProgressiveImage from "react-progressive-image";
import DropdownItem from "../dropdown-item/DropdownItem";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const VideoItem = (props) => {
    return (
        <div>
            <img alt="my-library-thumbnail"
                 className="my-library-thumbnail"
                 src={props.content.thumbnail_url} onClick={() => {
                props.thumbnailClicked(props.content.id)
            }}/>
            {
                props.content.url === "" &&
                <div className="my-library-thumbnail my-library-thumbnail-no-content" onClick={() => {
                    props.getVideoLink(props.content.id)
                }}>
                    <div className="my-library-thumbnail-no-content-text">
                        {
                            props.retry_video_url.isFetching ?
                                <img className="my-library-actions-img"
                                     src={assets.loading_blue}/>
                                :
                                "No content available"
                        }
                    </div>
                </div>
            }
            <div className="my-library-thumbnail-duration-container">
                <span className="my-library-thumbnail-duration-text">{props.content.durationFormatted}</span>
            </div>
        </div>
    )
}

const PictureItem = (props) => {
    return (
        <Zoom>
            <img alt="my-library-thumbnail"
                 className="my-library-thumbnail"
                 src={props.content.url}/>
        </Zoom>
    )
}
const ListItem = (props) => {

    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);

    return (
        <Row className="my-library-table-header no-margin" key={`my-library-row-${props.index}`}>
            <Col md="8" className="no-padding">
                <div className="display-flex">

                    <CustomInput
                        type="checkbox"
                        id={`mylibrary-checkbox-${props.index}`}
                        name={`mylibrary-checkbox-${props.index}`}
                        className="my-library-checkbox"
                        value={props.content.id}
                        {...(props.selectAllCheckbox
                            ? {checked: props.selectAllCheckbox}
                            : {checked: props.checkboxStore.includes(props.content.id)})}
                        onChange={props.checkboxToggle}
                    />

                    <ProgressiveImage
                        delay={1000}
                        src={props.content.thumbnail_url}
                        placeholder="placeholder"
                    >
                        {(src, loading) => {
                            return loading ? (
                                    <img alt="my-library-thumbnail"
                                         className="my-library-thumbnail"
                                         onClick={()=>{
                                             if(props.content.type === "video"){
                                                 props.thumbnailClicked(props.content.id)
                                             }
                                         }}
                                         src={assets.clipstore.placeholder}/>
                                ) :
                                (
                                    props.content.type === "picture"
                                        ?
                                        PictureItem(props)
                                        :
                                        VideoItem(props)
                                )

                        }}
                    </ProgressiveImage>

                    <div className="my-library-content-list">
                        <div className="my-library-content-title">
                            <span>{props.content.title}</span>
                            <span style={{fontSize: "11px"}}
                                  className="ml-2 badge badge-sm text-white">
                                {getAgeGroupDiv(props.content.age_group)}
                            </span>
                        </div>
                        <div className="my-library-content-description">{props.content.description}</div>
                        <div className="my-library-content-date">Uploaded
                            on <b>{moment(props.content.updated_at).format("ll")}</b></div>
                    </div>
                </div>
            </Col>
            <Col md="2" className="no-padding my-library-content-tags-title">
                {getTagsCommaSeparated(props.content.tags)}
            </Col>
            <Col md="2" style={{textAlign: 'right'}} className="no-padding ">
                <div className="my-library-content-action">
                    <span className="my-library-content-edit-title" onClick={() => {
                        props.editVideo(props.content.id)
                    }}>
                        <i className="fas fa-pencil-alt my-library-content-edit-icon"></i>Edit
                    </span>
                    <img src={popoverOpen ? assets.more_selected : assets.more} className="rotate-90"
                         id={`mylibrary-more-${props.index}`}/>
                </div>
            </Col>
            <Popover placement="bottom" isOpen={popoverOpen} target={`mylibrary-more-${props.index}`} toggle={toggle}>
                <PopoverBody className="my-library-actions-pop-over-body">
                    <div>
                        <DropdownItem
                            isFetching={props.publish_videos.isFetching}
                            onClick={() => {
                                toggle();
                                props.publishVideo(props.content.id)
                            }}
                            icon={assets.clipstore.more.publishVideo}
                            text={"Publish Content"}
                        />

                        <DropdownItem
                            isFetching={props.duplicate_videos.isFetching}
                            onClick={() => {
                                toggle();
                                props.duplicateVideo(props.content.id)
                            }}
                            icon={assets.clipstore.more.duplicateVideo}
                            text={"Duplicate"}
                        />

                        <DropdownItem
                            isFetching={props.delete_videos.isFetching}
                            onClick={() => {
                                toggle();
                                props.deleteVideo(props.content.id)
                            }}
                            icon={assets.clipstore.more.deleteVideo}
                            text={"Delete Content"}
                        />


                    </div>
                </PopoverBody>
            </Popover>
        </Row>
    );
}

export default ListItem;